'use client';

import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastIcon,
  ToastProvider,
  ToastTitle,
  type ToastVariant,
  ToastViewport,
} from '@/components/ui/toast';
import { useToast } from '@/hooks/use-toast';
import { useTranslations } from 'next-intl';

export function Toaster() {
  const { toasts } = useToast();
  // `Toaster` is mounted inside `NextIntlClientProvider` (the `[locale]`
  // layout), so this is safe here. `ToastClose` keeps an English default for
  // any consumer that renders it outside that provider.
  const t = useTranslations('Toast');

  return (
    <ToastProvider>
      {toasts.map(({ id, title, description, action, ...props }) => {
        // Extract variant for icon rendering
        const variant = props.variant as ToastVariant | undefined;

        return (
          <Toast key={id} {...props}>
            <div className='flex items-center gap-3'>
              <ToastIcon variant={variant ?? null} />
              <div className='grid gap-1 min-w-0'>
                {title && <ToastTitle>{title}</ToastTitle>}
                {description && (
                  <ToastDescription>{description}</ToastDescription>
                )}
              </div>
            </div>
            {action}
            <ToastClose closeLabel={t('close')} />
          </Toast>
        );
      })}
      <ToastViewport />
    </ToastProvider>
  );
}
